// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2lTXL","selected":"Chip_selected__34rBh"};